// 相手先 名寄せ（中身/TMS）。取込時の相手先"名"→ 正式名称・コード＋枝番・登録番号(T)。
// 出所: build_codemap.py / build_meishou.py（得意先CD＋枝番でマスタ照合）→ nameMap.json に凝縮。
//
// nameMap.json はここから static import しない（2026-08-24）。
// 同梱すると公開JSバンドルに得意先の正式名称・CD・枝番が丸ごと入る。
// バンドルは認証の外側にあり誰でも取得できるので、同梱＝公開と同じ意味になるため。
// 実体は masters/ に移し、認証つき Function から取る。**使う前に ensureMasters() を await する。**
import { authedJson } from '../../serverData.js'

const norm = (s) => (s == null ? '' : String(s).normalize('NFKC').replace(/　/g, ' ').replace(/\s+/g, ' ').trim())

// 正規化キーの逆引き索引（取込名の表記ゆれを吸収）。読み込み前は null＝「まだ引けない」。
let INDEX = null
let loading = null

function buildIndex(nameMap) {
  const idx = { seikyu: {}, shiharai: {} }
  for (const kind of ['seikyu', 'shiharai']) {
    for (const [name, rec] of Object.entries(nameMap[kind] || {})) {
      idx[kind][norm(name)] = { ...rec, alias: name }
    }
  }
  return idx
}

// 名寄せ表を読み込む。取込・移行の入口で1回 await する。多重呼び出しは同じ Promise を共有する。
export function ensureMasters() {
  if (INDEX) return Promise.resolve(INDEX)
  if (!loading) {
    loading = authedJson('api/masters/nameMap')
      .then((m) => { INDEX = buildIndex(m); return INDEX })
      .catch((e) => { loading = null; throw e }) // 次の呼び出しでやり直せるようにする
  }
  return loading
}

export const mastersReady = () => INDEX != null

// kind: 'seikyu'(得意先) | 'shiharai'(協力会社)
export function resolveName(kind, name) {
  if (!name) return null
  if (!INDEX) {
    // 黙って未名寄せで通すと、正式名称の無いデータが書き込まれて後から気づけない
    console.warn('名寄せ表が未読み込みです。ensureMasters() を先に await してください')
    return null
  }
  const n = norm(name)
  const idx = INDEX[kind] || {}
  if (idx[n]) return idx[n]
  // 前方一致（「トランコムさいたま情報センター」→「トランコムさいたま」等の揺れ救済）
  for (const key in idx) {
    if (n.startsWith(key) || key.startsWith(n)) return idx[key]
  }
  return null
}
export const resolveCustomer = (name) => resolveName('seikyu', name)
export const resolvePartner = (name) => resolveName('shiharai', name)
export const formalCustomer = (name) => (resolveCustomer(name)?.formal) || name
export const formalPartner = (name) => (resolvePartner(name)?.formal) || name

// 取込Trip に正式名称・コード＋枝番・登録番号を付与（importRun の確定時に使用）。
export function enrichTrip(trip) {
  const out = { ...trip }
  const c = resolveCustomer(trip.customerName)
  if (c) {
    out.customerFormal = c.formal
    if (c.cd != null) out.customerCode = c.cd
    if (c.eda != null) out.customerBranchNo = c.eda
  }
  if (trip.partnerName) {
    const p = resolvePartner(trip.partnerName)
    if (p) {
      out.partnerFormal = p.formal
      if (p.cd != null) out.partnerCode = p.cd
      if (p.eda != null) out.partnerBranchNo = p.eda
      if (p.tnum) out.partnerTnum = p.tnum // 適格請求書登録番号（支払お伺い書用）
    }
  }
  return out
}
